import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 1rem;
`;

const Heading = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

const Button = styled.button`
  margin: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  cursor: pointer;
  &:hover {
    background-color: rgb(184, 196, 219);
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

const QuestionBox = styled.div`
  padding: 5px 5px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background-color: #f9fafb;
`;

const QuestionText = styled.p`
  font-weight: bold;
  margin: 5px 5px;
`;

const AnswerOption = styled.div`
  margin: 5px 5px;
  display: flex;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    gap: 10px; /* Ensures space between radio and text */
    cursor: pointer;
    width: 100%;
    color: #000000;
  }

  input[type='radio'] {
    margin-right: 10px;
    cursor: pointer;
    width: 16px;
    height: 16px;
    appearance: radio;
    flex-shrink: 0; /* Prevents radio button from shrinking */
  }

  &.correct-answer {
    background-color: #d1ffd1;
    padding: 0px;
    border-radius: 5px;
  }
`;

const Score = styled.div`
  text-align: center;
  font-weight: bold;
  margin-top: 1rem;
  font-size: 1.2rem;
`;

const GenerateTest = ({ testTitle, questions }) => {
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [score, setScore] = useState(null);
  const [showCorrect, setShowCorrect] = useState(false);

  const handleAnswerChange = (questionId, answerId) => {
    setSelectedAnswers((prevState) => ({
      ...prevState,
      [questionId]: answerId,
    }));
  };

  const checkAnswers = () => {
    let correctCount = 0;
    questions.forEach((q) => {
      if (selectedAnswers[q.questionId] === q.correctAnswer) {
        correctCount++;
      }
    });

    setScore({
      correct: correctCount,
      total: questions.length,
      percentage: Math.round((correctCount / questions.length) * 100),
    });

    setShowCorrect(false);
  };

  const clearAnswers = () => {
    setSelectedAnswers({});
    setScore(null);
    setShowCorrect(false);
  };

  const showCorrectAnswers = () => {
    setShowCorrect(true);
  };

  return (
    <Container>
      <Heading>Test: {testTitle}</Heading>

      <ButtonContainer>
        <Button onClick={checkAnswers}>Sprawdź odpowiedzi</Button>
        <Button onClick={clearAnswers}>Wyczyść odpowiedzi</Button>
        <Button onClick={showCorrectAnswers}>Pokaż poprawne</Button>
      </ButtonContainer>

      {score && (
        <Score>
          Poprawnych odpowiedzi: {score.correct} / {score.total} ({score.percentage}%)
        </Score>
      )}

      <form method="post">
        <GridContainer>
          {questions.map((q) => (
            <QuestionBox key={q.questionId}>
              <QuestionText>{q.questionText}</QuestionText>
              {q.answers.map((a) => (
                <AnswerOption key={a.answerId} className={showCorrect && a.answerId === q.correctAnswer ? "correct-answer" : ""}
                >
                  <label>
                    <input
                      type="radio"
                      name={`question-${q.questionId}`}
                      value={a.answerId}
                      checked={selectedAnswers[q.questionId] === a.answerId} 
                      onChange={() => handleAnswerChange(q.questionId, a.answerId)}
                    />
                    <span>{a.answerText}</span>
                    </label>
                </AnswerOption>
              ))}
            </QuestionBox>
          ))}
        </GridContainer>
      </form>
    </Container>
  );
};

export default GenerateTest;